import React from "react";

const Button = (props) => {
	const { text, classes, onClick, disabled } = props;
	return (
		<button
			className={`font-semibold cursor-pointer p-1 px-2 rounded-md text-black drop-shadow-lg bg-primary-100 hover:bg-primary-200 transition-all ${
				classes ? classes : ""
			} ${disabled ? "opacity-50 cursor-not-allowed" : ""}`}
			disabled={disabled}
			onClick={() => {
				onClick();
			}}>
			{text}
		</button>
	);
};

export default Button;
